import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Toast } from 'ngx-toastr';

/**
 * Renders the same markup as angular2-toaster, which _toaster.scss and the Cypress specs rely on.
 * The fade in/out uses ngx-toastr's own CSS animation (toast-in on enter, toast-out on remove);
 * component styles are not inherited, so the keyframes are repeated in toaster-toast.component.scss.
 */
@Component({
  // Attribute selector, so ngx-toastr creates a <div> host (_toaster.scss styles `.toast-container > div`).
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[agrToasterToast]',
  template: `
    <div class="toast-content">
      <div class="toast-title">{{ title() }}</div>
      <div class="toast-message">
        <div>{{ message() }}</div>
      </div>
    </div>
  `,
  host: {
    '[style.--animation-easing]': 'params.easing',
    '[style.--animation-duration]': 'params.easeTime + "ms"',
    'animate.enter': 'toast-in'
  },
  styleUrls: ['./toaster-toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ToasterToastComponent extends Toast {}
